import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import {
  setComboFilters,
  setComboSortType,
  setFilter,
  setMulticityFilter,
  setMulticitySortType,
  setReturnFilter,
  setReturnSortType,
  setSortType,
} from "../flightSlice";
import { generateRequestId } from "../../../_helpers/miscUtils";

export const getAllFlights = createAsyncThunk(
  "Flight/FindAllFlight",
  async (payload: any) => {
    const response = await axiosApiInstance.post(
      `${API_URL}/fms/v1/air-search-all`,
      payload
    );
    return response.data;
  }
);

export const getAllEtraveFlights = createAsyncThunk(
  "AirlineSearch/Air_Search",
  async (payload: any) => {
    const Request_Id = generateRequestId();
    const response = await axiosApiInstance.post(
      `${API_URL}/AirlineSearch/Air_Search`,
      { ...payload, Request_Id }
    );
    return response.data;
  }
);

export const setSortTypeAsync = createAsyncThunk(
  "flight/setSortTypeAsync",
  async (
    payload: { type?: string; selectedValue: any; index?: number },
    { dispatch }
  ) => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 0));

      const { type, selectedValue, index } = payload;

      if (type === "return") {
        dispatch(setReturnSortType(selectedValue));
      } else if (type === "multicity") {
        dispatch(setMulticitySortType({ sortType: selectedValue, index }));
      } else if (type === "combo") {
        dispatch(setComboSortType(selectedValue));
      } else {
        dispatch(setSortType(selectedValue));
      }
    } catch (error) {
      console.error("Error setting sort type:", error);
    }
  }
);

export const setFilterAsync = createAsyncThunk(
  "flight/setFilterAsync",
  async (payload: any, { dispatch }) => {
    const {
      option,
      selectedOptions,
      filterKey,
      type,
      index,
      returnFilters,
      multicityFilters,
      comboFilters,
      onwardFilters,
    } = payload;
    try {
      // Special handling for priceRange (which is an object)
      const updatedValue =
        filterKey === "priceRange"
          ? option // For priceRange, use the option directly (it's already { min, max })
          : Array.isArray(selectedOptions) && selectedOptions.includes(option)
          ? selectedOptions.filter((item) => item !== option)
          : [...selectedOptions, option];

      await new Promise((resolve) => setTimeout(resolve, 0));

      switch (type) {
        case "return":
          dispatch(
            setReturnFilter({
              ...returnFilters,
              [filterKey]: updatedValue,
            })
          );
          break;
        case "multicity":
          if (typeof index === "number") {
            const updatedMulticityFilters = [...multicityFilters];
            updatedMulticityFilters[index] = {
              ...updatedMulticityFilters[index],
              [filterKey]: updatedValue,
            };
            dispatch(setMulticityFilter(updatedMulticityFilters));
          }
          break;
        case "combo":
          if (typeof index === "number") {
            const updatedComboFilters = [...comboFilters];
            updatedComboFilters[index] = {
              ...updatedComboFilters[index],
              [filterKey]: updatedValue,
            };
            dispatch(setComboFilters(updatedComboFilters));
          }
          break;
        case "onward":
        default:
          dispatch(setFilter({ ...onwardFilters, [filterKey]: updatedValue }));
          break;
      }
    } catch (error) {
      console.error("Error in filter update:", error);
    }
  }
);
